/**
 * @description: API接口管理文件
 * 所有接口变量定义均以: '_API' 结尾
 * 在每个接口上面写好接口用途注释
 */

export default {
	// 通知服务端发放奖励接口
	NOTICE_SERVER_REWARD_API: '/task/receive_reward',
	// 获取福利活动页面数据接口
	GET_TASK_PAGE_INFO_API: '/task/get_task_page_info',
	// 获取福利任务页签到信息
	GET_WELFARE_TASK_PAGE_INFO_API: '/welfare/GetWelfarePageInfo',
	// 福利任务页签到接口
	WELFARE_SIGN_IN_API: '/welfare/SignIn',
	// 获取用户收益信息
	GET_WALLET_API: '/me/wallet',
	// 获取用户签到信息接口
	GET_SIGN_INFO_API: '/task/get_sign_in_list',
	// 福利任务页领取奖励接口
	GET_WELFARE_REWARD: '/welfare/GetReward',
	// 通知服务端更新任务状态
	UPDATE_TASK_PROGRESS_API: '/welfare/TaskProgress',
	// 获取单条福利任务进度
	REFRESH_TASK_PROGRESS: '/welfare/GetOneTask',
	// 获取福利体系 tab 配置；包括（tab显隐，红点配置，ab测试）
	GET_WELFARE_TAB_API: '/welfare/getDot',
	// 获取福利体系 ab 配置
	GET_WELFARE_AB_API: '/welfare/getTabAb',
	// 获取福利体系红点状态接口
	GET_PAGE_DOT_API: '/welfare/GetPageDot',
	// 获取在线奖励完成弹窗按钮任务配置
	GET_ONLINE_COMPLETE_API: '/config/video_window',
	// 获取在线奖励信息
	GET_ONLINE_INFO_API: '/task/GetOnlineReward',
	// 获取整点宝箱弹窗配置
	GET_CLOCK_SIGN_API: '/task/clock_sign_in',
	// 获取整点宝箱信息
	GET_CLOCK_SIGN_INFO_API: '/task/GetClockSignIn',
	// 福利活动任务通知服务端发放奖励接口
	NOTICE_TASK_REWARD_API: '/task/receive_link_task_reward',
	// 福利活动任务通知服务端延时发放奖励接口
	NOTICE_COMPLETE_LINK_API: '/task/complete_link_task',
	// 获取小红包列表接口
	GET_TIMING_RED_PACKS_API: '/task/get_timing_red_packs',
	// 获取小红包配置列表接口
	GET_SM_RED_CONF_API: '/task/get_small_red_envelope_cfg',
	// 红包雨配置接口
	RED_ENVELOPE_RAIN_API: '/config/red_envelope_rain',
	// 百变宝箱-检测宝箱开启状态
	CHECK_HD_FD_STATUS_API: '/task/check_hundredfold_status',
	// 获取宝箱任务
	GET_CHEST_TASK: '/welfare/GetChestTask',
	// 开始任务宝箱
	CHEST_TASK_START: '/welfare/chestTaskStart',
	// 更新宝箱任务的进度
	UPDATE_CHEST_STATUS: '/welfare/chestTaskFinish',
	// 领取任务奖励
	GET_CHEST_TASK_REWARD: '/welfare/chestTaskReward',
	// 领取宝箱奖励
	GET_CHEST_REWARD: '/welfare/ChestReward',
	// 承接回归用户-获取回归任务列表
	GET_REGRESS_TASK_API: '/welfare/getRegressTask',
	// 承接回归用户-普通签到接口
	SIGN_IN_REGRESS_API: '/welfare/SignInRegress',
	//  获取商城数据
	GET_MALL_PAGE_INFO: '/store_page/get_page_info',
	// 签到详情页接口
	GET_MY_WELFARE_SIGN_API: '/signIn/getMyWelfareSignIn',
	// 插屏广告信息
	GET_AD_INTERSTITIAL_INFO: '/task/getAdInterstitialInfo',
	GET_RECHARGE_ENTRANCE_POP: '/vip/rechargeEntrancePop',
	// 获取是否是合规组
	GET_IS_COMPLIANCE: '/common/IsCompliance',
	// 小米金融授权信息
	GET_FINANCE_AUTH: '/Finance/Auth',
	// 小米金融判断手机号是否绑定
	GET_FINANCE_BIND_MOBILE: '/Finance/CheckBindMobile',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/task.js